import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './App.css';
import { useNavigate } from 'react-router-dom';

interface Word {
    japanese: string;
    danish: string;
}

interface WordSearchProps {
    onNextMode?: () => void;
}

function WordSearch({ onNextMode }: WordSearchProps) {
    const navigate = useNavigate();
    const [items, setItems] = useState<Word[]>([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const username = process.env.REACT_APP_API_USERNAME;
                const password = process.env.REACT_APP_API_PASSWORD;
                const token = btoa(`${username}:${password}`);
                const response = await axios.get<Word[]>(`${process.env.REACT_APP_API_URL}/Word/AllWords`,
                    {
                        headers: {
                            Authorization: `Basic ${token}`,
                        },
                    }
                );
                setItems(response.data);
                setLoading(false);
            } catch (err) {
                setError('An error occurred while fetching data.');
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // Filter words by search term (case-insensitive, matches either Japanese or Danish)
    const filteredItems = items.filter(
        item =>
            item.japanese.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.danish.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Handler for Enter key in search box
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' && onNextMode) {
            onNextMode();
        }
    };

    return (
        <div className="quiz-container">
            {!onNextMode && <button className="close-button" onClick={() => navigate('/')}>&times;</button>}
            <h2 className="quiz-title">Word Search</h2>
            <input
                type="text"
                className="word-search-input"
                placeholder="Search for a word..."
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                onKeyDown={handleKeyDown}
            />
            {loading && <p>Loading...</p>}
            {error && <p>{error}</p>}
            <div className="word-list">
                {filteredItems.length === 0 && !loading && <p>No words found.</p>}
                {filteredItems.map((item, index) => (
                    <div key={index} className="word-item">
                        <p>{item.japanese} - {item.danish}</p>
                    </div>
                ))}
            </div>
            <p style={{fontSize: '0.9em', color: '#888', marginTop: '1em'}}>Tryk Enter med tomt felt for næste quiz</p>
        </div>
    );
}

export default WordSearch;